export const isMac = navigator.userAgent.indexOf('Mac OS X') !== -1
export const isWindows = navigator.userAgent.indexOf('Windows') !== -1
export const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
